import { render } from "./Carriers.vue?vue&type=template&id=039b800c&ts=true"
import script from "./Carriers.vue?vue&type=script&lang=ts"
export * from "./Carriers.vue?vue&type=script&lang=ts"

import "./Carriers.vue?vue&type=style&index=0&id=039b800c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__